module.exports = __webpack_public_path__ + "static/media/github.93070228.svg";